<template>
  <div>
    <b-row>
      <b-col>
        <h5>Filtrar por</h5>
      </b-col>
      <!-- <b-col sm="2">
        <downloadExcel
          class="btn btn-warning col-sm-12"
          :data="filteredItems()"
          worksheet="Gestiones"
          name="conteo-gestiones.xls"
          :fields="json_fields"
          :before-generate="startDownload()"
          :before-finish="finishDownload()"
          >Exportar</downloadExcel
        >
      </b-col> -->
    </b-row>

    <b-row>
      <b-col>
        <b-form-group>
          <label class="mb-0" for="txtFechaDesde"
            >Fecha importación desde</label
          >
          <b-form-input
            type="date"
            id="txtFechaDesde"
            v-model="range_created.startDate"
            :max="range_created.endDate == '' ? maxDate : range_created.endDate"
            @blur="changeDateImport()"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label class="mb-0" for="txtFechaHasta"
            >Fecha importación hasta</label
          >
          <b-form-input
            type="date"
            id="txtFechaHasta"
            v-model="range_created.endDate"
            :min="range_created.startDate"
            :max="maxDate"
            @blur="changeDateImport()"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col class="text-center">
        <b-form-group>
          <label class="mb-0 col-sm-12">Con Gestión</label>
          <c-switch
            v-model="with_management"
            class="mt-2 mx-auto"
            color="primary"
            label
            variant="pill"
            v-bind="labelTxt"
            :size="'sm'"
            @change="changeWithManagement()"
          />
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0" for="txtFechaDesdeTask"
            >Fecha gestión desde</label
          >
          <b-form-input
            type="date"
            id="txtFechaDesdeTask"
            v-model="range_task_management.startDate"
            :max="
              range_task_management.endDate == ''
                ? maxDate
                : range_task_management.endDate
            "
            @blur="changeDateTask()"
            :disabled="!with_management"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label class="mb-0" for="txtFechaHastaTask"
            >Fecha gestión hasta</label
          >
          <b-form-input
            type="date"
            id="txtFechaHastaTask"
            v-model="range_task_management.endDate"
            :min="range_task_management.startDate"
            :max="maxDate"
            @blur="changeDateTask()"
            :disabled="!with_management"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Deudor</label>
          <b-form-input
            type="text"
            v-model="customer_debtor_identification_filter"
            @blur="getDebtors()"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group>
          <label class="mb-0">Estado</label>
          <b-form-select v-model="status_filter" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Estado--</option>
            </template>
            <option value="P">Pausado</option>
            <option value="A">Activo</option>
            <option value="C">Cerrado</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label class="mb-0">Tipificación</label>
          <b-form-select v-model="type_filter" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Tipificación --</option>
            </template>
            <option v-for="item in lstType" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0" for="cmbCuenta">Cliente</label>
          <b-form-select
            v-model="customer_id_filter"
            id="cmbCuenta"
            @change="getDebtors()"
          >
            <template slot="first">
              <option :value="null">
                -- Por favor seleccione una opción --
              </option>
            </template>

            <option
              v-for="item in lstCustomers"
              :key="item.id"
              :value="item.id"
            >
              {{ item.business_name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Cobrador</label>
          <b-form-select
            v-model="staff_id_filter"
            @change="getDebtors()"
            :disabled="role_id == 1 || role_id == 8 ? false : true"
          >
            <template slot="first">
              <option :value="null">-- Cobrador--</option>
            </template>
            <option v-for="item in lstStaffs" :key="item.id" :value="item.id">
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label for="cmbStaff" class="mb-0">Comercial</label>
          <b-form-select
            v-model="customer_staff_id_filter"
            id="cmbStaff"
            @change="getDebtors()"
          >
            <template slot="first">
              <option :value="null">-- Comercial --</option>
            </template>
            <option
              v-for="item in lstComercialStaffs"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label for="cmbEtapa" class="mb-0">Etapa de cobro</label>
          <b-form-select
            v-model="process_id_filter"
            id="cmbEtapa"
            @change="getDebtors()"
          >
            <template slot="first">
              <option :value="null">-- Etapa de cobro --</option>
            </template>
            <option v-for="item in lstProcess" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <b-table
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              :responsive="true"
              :items="filteredItems()"
              :fields="fields"
              :filter="filter"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template slot="actions" slot-scope="data">
                <b-button
                  size="sm"
                  variant="primary"
                  class="mr-1 btn-custom-size"
                  @click="viewDebtor(data.item.id)"
                  title="Ver"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
              </template>
            </b-table>

            <hr />

            <div class="row">
              <div class="col-sm-4">
                Mostrando
                {{
                  filteredItems().length > perPage * currentPage
                    ? perPage * currentPage
                    : filteredItems().length
                }}
                de {{ filteredItems().length }} registros
              </div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    align="right"
                    size="sm"
                    :total-rows="
                      filteredItems().length == null
                        ? 0
                        : filteredItems().length
                    "
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<style type="text/css">
  .table thead th {
    white-space: nowrap;
    /* background-color: aquamarine; */
  }
</style>

<script>
import moment from "moment";
import { Switch as cSwitch } from "@coreui/vue";
export default {
  name: "ManagementCount",
  components: { cSwitch },
  props: {
    caption: {
      type: String,
      default: "DEUDORES",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      currentPage: 1,
      perPage: 10,
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      isCustomer: false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      user_id: JSON.parse(localStorage.getItem("auth"))[0].id,
      customer_id: null,
      range_task_management: {
        startDate: "",
        endDate: "",
      },

      fields: [
        {
          key: "selected",
          name: "Selected",
          label: "",
          class: "options-column",
        },
        { key: "status_name", label: "Estado", sortable: true },
        { key: "process_name", label: "Etapa", sortable: true },
        { key: "created_at_", label: "Importación", sortable: true },
        { key: "task_management_date", label: "Gestión", sortable: true },
        { key: "customer_business_name", label: "Cliente", sortable: true },
        { key: "business_name", label: "Deudor", sortable: true },

        { key: "total_call", label: "Llamadas", sortable: true },
        { key: "total_whatsapp", label: "Whatsapp", sortable: true },
        { key: "total_message", label: "Mensajes", sortable: true },
        { key: "total_visit", label: "Visitas", sortable: true },
        { key: "total_letter", label: "Cartas", sortable: true },
        { key: "total_email", label: "Correos", sortable: true },
        { key: "total_observation", label: "Observaciones", sortable: true },

        { key: "actions", label: "Ver" },
      ],

      json_fields: {
        Estado: "status_name",
        Etapa: "process_name",
        "Fecha De Importación": "created_at_",
        "Fecha De Gestión": "task_management_date",
        Cliente: "customer_business_name",
        Deudor: "business_name",
        "NIT / CC Deudor": "identification",
        "DV Deudor": "check_digit",
        Tipificación: "type_name",
        Llamadas: "total_call",
        Whatsapp: "total_whatsapp",
        Mensajes: "total_message",
        Visitas: "total_visit",
        Cartas: "total_letter",
        Correos: "total_email",
        Observaciones: "total_observation",
      },
      status: null,
      items: [],
      pagination: {},
      filter: null,
      tableData: [],
      tableHeader: [],
      errores: [],
      mostrarResumen: false,
      rowCount: -1,
      type_id: null,

      // FILTROS DE BUSQUEDA
      customer_debtor_identification_filter: null,
      created_at_filter: null,
      status_filter: null,
      type_filter: null,
      customer_id_filter: null,
      staff_id_filter: null,
      customer_staff_id_filter: null,
      process_id_filter: null,

      // LISTAS PARA LOS FILTROS
      lstServiceOrder: [],
      lstStaffs: [],
      lstTypeTaskManagement: [],
      lstType: [],
      lstCustomers: [],
      lstComercialStaffs: [],
      lstProcess: [],
      laravelData: {},
      limit: 10,
      showDisabled: true,
      size: "small",
      align: "right",
      staff_id: null,

      // NUEVOS FILTROS DESDE HASTA
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      range_created: {
        startDate: moment(String(new Date("2009", "12", "01"))).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },
      with_management: false,
      labelTxt: {
        dataOn: "Si",
        dataOff: "No",
      },
    };
  },
  mounted() {
    this.initParameters();
    this.getDebtors();
  },
  computed: {},
  methods: {
    initParameters() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.isCustomer = auth[0].customer_id != null ? true : false;
      this.customer_id = auth[0].customer_id;
      this.staff_id_filter = this.role_id == 1 || this.role_id == 8 ? null : auth[0].staff_id;

      //LISTADO DE STAFF'S, 43: PREJURIDICO
      this.$http.get(`${this.$urlApi}staffs/type/43?token=${this.token}`).then(
        (response) => {
          this.lstStaffs = response.data.data;
          // console.log(response.data.data);
        },
        (error) => {
          console.log(error);
        }
      );

      // TIPIFICACIÓN DEUDOR
      this.$http.get(`${this.$urlApi}parameters/15?token=${this.token}`).then(
        (response) => {
          this.lstType = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // LISTA DE CUENTAS
      let url = `${this.$urlApi}customers/staff?token=${this.token}`;
      if (auth[0].role_id !== 1) auth[0].filter_staff_id = auth[0].staff_id;

      // console.log(auth[0]);

      this.$http
        .post(url, JSON.stringify(auth), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          (response) => {
            // console.log(response);
            this.lstCustomers = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );

      //LISTADO DE STAFF'S, 42: COMERCIAL
      this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
        (response) => {
          this.lstComercialStaffs = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // PROCESOS
      this.$http.get(`${this.$urlApi}process?token=${this.token}`).then(
        (response) => {
          this.lstProcess = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    filteredItems() {
      return this.items.filter((item) => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.fieldKeys().forEach((key) => {
          keep =
            keep &&
            (this.selectVal[key] === undefined ||
              item[key] === this.selectVal[key]);
        });
        return keep;
      });
    },
    fieldKeys() {
      let keys = [];
      return keys;

      if (this.items[0] === undefined) return null;
      else return Object.keys(this.items[0]);
    },
    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      //console.log(this.fieldKeys())
      this.fieldKeys().forEach((key) => {
        const vals = this.items.map((item) => item[key]);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals));
      });

      return options;
    },
    changeDateImport() {
      if (
        this.range_created.startDate != "" &&
        this.range_created.endDate != ""
      ) {
        this.getDebtors();
      } else return;
    },
    changeDateTask() {
      if (
        this.range_task_management.startDate != "" &&
        this.range_task_management.endDate != ""
      ) {
        this.getDebtors();
      } else return;
    },
    getDebtors: function (page = 1) {
      showLoader();
      let authAux = JSON.parse(this.auth);
      authAux[0].customer_id = this.customer_id_filter;
      authAux[0].customer_debtor_identification = this.customer_debtor_identification_filter;
      authAux[0].status = this.status_filter;
      authAux[0].type = this.type_filter;
      authAux[0].staff_id_filter = this.staff_id_filter;
      authAux[0].process_id = this.process_id_filter;
      authAux[0].start_date_created_at = moment(
        this.range_created.startDate
      ).format("YYYY-MM-DD");
      authAux[0].end_date_created_at = moment(
        this.range_created.endDate
      ).format("YYYY-MM-DD");

      authAux[0].pre_written = this.pre_written;

      authAux[0].customer_staff_id_filter = this.role_id == 2 ? authAux[0].staff_id : this.customer_staff_id_filter;

      if (
        this.range_task_management.startDate != "" &&
        this.range_task_management.endDate != ""
      ) {
        authAux[0].start_date_task_management = moment(
          this.range_task_management.startDate
        ).format("YYYY-MM-DD");
        authAux[0].end_date_task_management = moment(
          this.range_task_management.endDate
        ).format("YYYY-MM-DD");
      }

      let url = `${this.$urlApi}debtors/indicators/managementcount?token=${this.token}&page=${page}`;

      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            // console.clear();
            console.log(response);
            this.items = response.data.data;
            // this.items = response.data.data.data;
            // this.laravelData = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getRowCount(items) {
      return items.length;
    },
    viewDebtor(id) {
      let url = `${location.origin}/#/debtors/view/${id.toString()}`;
      window.open(url, "_blank");
    },
    startDownload() {
      // showLoader();
    },
    finishDownload() {
      // hideLoader();
    },
    formatDateDescription(value) {
      if (!value) return "";
      else {
        if (value == "--") return value;
        else {
          var d = moment(value).format("DD");
          var m = moment(value).format("MMM");
          var a = moment(value).format("YYYY");
          return d + " de " + m + " " + a;
        }
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    isAfter10Days(item) {
      if (item.type == 66) return false;
      var fecha = moment(item.task_management_date, "YYYY-MM-DD HH:mm:ss");
      var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
      var dias = fechaActual.diff(fecha, "days");
      return dias > 10 ? true : false;
    },
    changeWithManagement() {
      if (this.with_management) {
        this.range_task_management = {
          startDate: moment(String(sumarDias(new Date(), -30))).format(
            "YYYY-MM-DD"
          ),
          endDate: moment(String(new Date())).format("YYYY-MM-DD"),
        };
      } else {
        this.range_task_management.startDate = "";
        this.range_task_management.endDate = "";
      }
      this.getDebtors();
    },
  },
};
</script>
